import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { imgUrl, money, useProducts } from "./useProducts";

/** Admin-picked `related` ids first; otherwise other active pieces from the same category, then anything else. */
export const suggestFor = (products, sources, limit = 4) => {
  const list = Array.isArray(sources) ? sources : [sources];
  const exclude = new Set(list.map((s) => s?.id).filter(Boolean));
  const picked = [];
  const push = (p) => { if (p && !exclude.has(p.id) && p.remaining !== 0 && !picked.find((x) => x.id === p.id)) picked.push(p); };
  list.forEach((s) => (s?.related || []).forEach((id) => push(products.find((p) => p.id === id))));
  if (picked.length < limit) list.forEach((s) => products.filter((p) => p.category === s?.category).forEach(push));
  if (picked.length < limit) products.forEach(push);
  return picked.slice(0, limit);
};

export const SuggestedProducts = ({ sources, title = "Complete the look", onPick, limit = 4, testId = "suggested-products", compact = false }) => {
  const products = useProducts();
  const navigate = useNavigate();
  const picks = suggestFor(products, sources, limit);
  if (!picks.length) return null;
  const open = (p) => (onPick ? onPick(p) : navigate(`/shop/${p.category}?open=${p.slug}`));
  return (
    <section data-testid={testId} className={compact ? "mt-6" : "mt-8 border-t border-[#e3e2dc] pt-6"}>
      <p className="font-mono-d text-[10px] uppercase tracking-[0.25em] text-[#5f5e5a]">{title}</p>
      <div className={`mt-3 grid gap-3 ${compact ? "grid-cols-2" : "grid-cols-2 sm:grid-cols-4"}`}>
        {picks.map((p) => {
          const from = Math.min(...p.options.map((o) => o.price));
          return (
            <button key={p.id} type="button" data-testid={`suggested-${p.slug}`} onClick={() => open(p)} className="group text-left rounded-xl border border-[#e3e2dc] bg-[#ffffff] overflow-hidden hover:border-[#ff2a85] transition-colors">
              <span className="block aspect-[4/5] bg-[#f3f2ec] overflow-hidden">
                {p.image && <img src={imgUrl(p.image)} alt={p.name} className={`h-full w-full object-cover ${p.position || "object-top"} group-hover:scale-[1.04] transition-transform duration-500`} />}
              </span>
              <span className="block p-2.5">
                <span className="block font-display font-extrabold uppercase text-[10px] leading-tight line-clamp-2">{p.name}</span>
                <span className="mt-1 flex items-center justify-between">
                  <span className="font-mono-d text-[11px]">{p.options.length > 1 ? `from ${money(from)}` : money(from)}</span>
                  <ArrowUpRight size={12} className="text-[#5f5e5a] group-hover:text-[#ff2a85]" />
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
};
